import React, { Component } from 'react';

import Login from './Login';
import Register from './Register';
import Basic from './Basic';
import ForgotPassword from './ForgotPassword';

class LoginOrRegister extends Component {
  render() {
    switch (this.props.page) {
      case 'login':
        return (
          <Login
            email={this.props.email}
            onPageChange={this.props.onPageChange}
          />
        );
      case 'register':
        return (
          <Register
            email={this.props.email}
            onPageChange={this.props.onPageChange}
          />
        );
      case 'basic':
        return (
          <Basic
            type={this.props.type}
            onPageChange={this.props.onPageChange}
          />
        );
      case 'forgot-password':
        return <ForgotPassword onPageChange={this.props.onPageChange} />;
      default:
        return <Login onPageChange={this.props.onPageChange} />;
    }
  }
}

export default LoginOrRegister;
